import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import * as actionTypes from './actionTypes';
import {notify} from '../../helpers/utility';

export const modeChangeStart = () => {
  return {
    type: actionTypes.AGENT_MODE_CHANGE_START,
  };
};

export const modeChangeFail = (error) => {
  return {
    type: actionTypes.AGENT_MODE_CHANGE_FAIL,
    error: error,
  };
};

export const modeChangeSuccess = (agentId, mode, agentState) => {
  return {
    type: actionTypes.AGENT_MODE_CHANGE_SUCCESS,
    agentId: agentId,
    mode: mode,
    agentState: agentState,
  };
};

export const modeUpdate = (agentId, mode, agentState) => {
  return {
    type: actionTypes.AGENT_MODE_UPDATE,
    agentId: agentId,
    mode: mode,
    agentState: agentState,
  };
};

export const modeChange = (agentId, mode, agentState) => {
  return (dispatch) => {
    dispatch(modeChangeStart());
    ctiRequest['CTI_AGENT_MODE'].agent_id = agentId;
    //MANUAL,DIALER,AUTO_PREVEIW_ENABLE,AUTO_PREVEIW_DISABLE
    if(mode === 'PREVIEW'){
      mode = 'MANUAL';
    }else if(mode === 'PROGRESSIVE'){
      mode = 'DIALER';
    }
    ctiRequest['CTI_AGENT_MODE'].mode = mode;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_AGENT_MODE'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_AGENT_MODE'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          dispatch(modeChangeSuccess(agentId, mode, agentState));
        } else {
          dispatch(modeChangeFail(result.data.response.reason));
          notify('Mode Change Error: ' + result.data.response.reason, 'agent-mode');
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Mode Change Error', 'agent-mode');
        dispatch(modeChangeFail(err));
      });
  };
};
